module.exports = __webpack_public_path__ + "static/img/silica_256.3d5ee0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/silica_256.png
// module id = cTEu
// module chunks = 0